import { TOOL_CHECKOUTS_CRUD_ACTION_CREATORS } from '../actions/tool_checkouts_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const toolCheckoutsRestCrudThunksForSupplier = new RestCrudThunks(
	'checkouts',
	'checkout',
	'checkout',
	'checkouts',
	TOOL_CHECKOUTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

export const fetchToolUsageHistoryForSupplier = (
	toolId,
	params,
	targetCollectionName = null,
	pagination = null,
	sorting = null,
	filters = null,
	addToTargetCollection = false
) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${ROLE_TYPES.SUPPLIER}/inventory/tools/${toolId}/checkouts`;

	if (pagination) {
		const paginationQuery = {
			offset: (pagination.current - 1) * pagination.pageSize,
			limit: pagination.pageSize,
		};
		params = {
			...params,
			...paginationQuery,
		};
	}

	if (sorting) {
		const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
		params = {
			...params,
			...sortingQuery,
		};
	}

	if (filters) {
		params = {
			...params,
			...filters,
		};
	}

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(TOOL_CHECKOUTS_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));

			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign(
						{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
						params
					)
				)
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TOOL_CHECKOUTS_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
						reject(d.message);
					} else {
						dispatch(
							TOOL_CHECKOUTS_CRUD_ACTION_CREATORS.fetchSuccess(
								d.data,
								d.count,
								targetCollectionName,
								{
									...pagination,
									total: d.count,
								},
								sorting,
								filters,
								addToTargetCollection
							)
						);
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TOOL_CHECKOUTS_CRUD_ACTION_CREATORS.fetchError(d.message, d.data));
					reject(d.message);
				});
		});
	};
};
